var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',{ref:"gallery_swiper",attrs:{"options":_vm.options}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev swiper-button-white",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next swiper-button-white",attrs:{"slot":"button-next"},slot:"button-next"})],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-594b19ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./_js/components/Gallery.vue
// module id = 78
// module chunks = 0